import { Mic, Send } from '@mui/icons-material';
import { Dialog, DialogContent } from '@mui/material';
import React, { useState, useRef, useEffect } from 'react';
import AppLayout from '../../../../layout/components/AppLayout';
import assistantServices from '../assistantServices';
import AssistSetting from '../components/AssistSetting';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

function AssistentPage() {
    const [msgLog, setMsgLog] = useState([]);
    const [msg, setMsg] = useState("");
    
    // Set default provider and specific model on load
    const [selectAIProvider, setSelectAIProvider] = useState('OPENROUTER');
    const [selectedModel, setSelectedModel] = useState('google/gemma-4-26b-a4b-it:free');
    const [selectedTone, setSelectedTone] = useState('Snarky');         
    const [selectedLanguage, setSelectedLanguage] = useState('Haryanavi');
    
    const [dialogStatus, setDialogStatus] = useState(false);
    const [thinking, setThinking] = useState(false);
    
    const messagesEndRef = useRef(null);
    const transcriptRef = useRef("");

    // Auto-scroll to the bottom of the chat log on new messages
    useEffect(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [msgLog, thinking]);

    const speak = (text) => {
        let voiceIndex = sessionStorage.getItem("voiceIndex");
        var uttr = new SpeechSynthesisUtterance();
        uttr.text = text;
        uttr.voice = speechSynthesis.getVoices()[voiceIndex];
        speechSynthesis.speak(uttr);
    };

    const submitMessage = (textToSend) => {
        const currentMsg = typeof textToSend === 'string' ? textToSend : msg;
        if (!currentMsg || !currentMsg.trim()) return;

        const userEntry = { deviceName: "You", msg: currentMsg };

        setMsgLog(prevLog => [...prevLog, userEntry]);
        setMsg("");

        setThinking(true);
        setDialogStatus(true);

        // Send message along with provider and model choice
        assistantServices.chat({ 
            message: currentMsg, 
            provider: selectAIProvider,
            model: selectedModel,
            tone: selectedTone,
            language: selectedLanguage
        })
            .then(res => {
                const assistantEntry = { deviceName: "Megamind", role: "assistant", msg: res.reply };
                speak(res.reply);
                setMsgLog(prevLog => [...prevLog, assistantEntry]);
            })
            .catch(error => {
                console.log(error);
            })
            .finally(() => {
                setThinking(false);
                setDialogStatus(false);
            });
    };

    const listen = () => {
        let SR = window.SpeechRecognition || window.webkitSpeechRecognition;
        if (!SR) {
            alert("Speech Recognition is not supported in this browser.");
            return;
        }

        let r = new SR();
        r.start();

        r.onstart = () => {
            setDialogStatus(true);
        };

        r.onresult = (e) => {
            const transcript = e.results[0][0].transcript;
            setMsg(transcript);
            transcriptRef.current = transcript;
        };

        r.onend = () => {
            setDialogStatus(false);
            if (transcriptRef.current) {
                submitMessage(transcriptRef.current);
                transcriptRef.current = "";
            }
        };
    };

    return (
        <AppLayout>
            <div className="container-fluid">
                
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">

                            <div className='card-header py-0'>
                                <span className='float-end'>
                                <AssistSetting
                                    selectedModel={selectedModel}
                                    setSelectedModel={setSelectedModel}
                                    selectAIProvider={selectAIProvider}
                                    setSelectAIProvider={setSelectAIProvider}
                                    selectedTone={selectedTone}
                                    setSelectedTone={setSelectedTone}
                                    selectedLanguage={selectedLanguage}
                                    setSelectedLanguage={setSelectedLanguage}
                                />
                                </span>
                            </div>

                            <div className=" card-body p-1" style={{ overflowY: "auto", height: "75vh" }}>
                                {msgLog.map((log, i) => (
                                    <div key={i} className='my-2'>
                                        <span className="fw-bold">{log.deviceName}</span> : 
                                        <ReactMarkdown remarkPlugins={[remarkGfm]}>
                                         {log.msg}
                                         </ReactMarkdown>
                                        <hr/>
                                    </div>
                                ))}
                                <div ref={messagesEndRef}></div>
                            </div>
                            <div className="input-group my-2">
                                <textarea 
                                    rows={2}
                                    className="form-control" 
                                    value={msg} 
                                    onChange={(e) => setMsg(e.target.value)} 
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' && !e.shiftKey) {
                                            e.preventDefault(); 
                                            submitMessage();
                                        }
                                    }}
                                    placeholder="Type a message... (Shift+Enter for new line)"
                                />
                                <button type="button" className="btn btn-outline-default" onClick={listen}><Mic /></button>
                                <button type="button" className="btn btn-primary" onClick={() => submitMessage()}><Send /></button>
                            </div>
                            <Dialog
                                open={dialogStatus}
                                maxWidth="md"
                            >
                                <DialogContent>
                                    <h4>{thinking ? "Let me think ..." : "Listening..."}</h4>
                                    <div className='gtoken-mic'></div>
                                </DialogContent>
                            </Dialog>
                        </div>
                    </div>
                </div>
            </div>
        </AppLayout>
    );
}

export default AssistentPage;